/**
 * Renders the app header
 */

import React from 'react';
import { observer } from 'mobx-react';

// Config
import { config } from '../../config';

// Translation
import translate from '../translate/Translate';

// Components
import Accessibility from './Accessibility';
import Button from './Button';

// Icons
import * as icons from '../ui/Icons';
import { getUrlSegment } from '../../helpers';

const Header = observer(
  class Header extends React.Component {

    componentDidMount() {
      const { BrandStore, UserStore } = this.props.store;

      const tryFetchBranding = (attempt = 0) => {
        if (attempt > 5 || !UserStore.installSid) {
          setTimeout(() => tryFetchBranding(++attempt), 500);
        } else {
          const payload = {
            context: 'helpButton'
          }
          let assessmentGroupSid = UserStore.assessmentGroupSid;

          if (!assessmentGroupSid) {
            const urlGroupSid = getUrlSegment(2).match(/^AG[a-f0-9]{32}$/);
            assessmentGroupSid = urlGroupSid ? urlGroupSid[0] : assessmentGroupSid;
          }

          payload.installSid = UserStore.installSid;
          payload.assessmentGroupSid = assessmentGroupSid;

          BrandStore.getCalculatedBrandingContent(payload);
        }
      };

      tryFetchBranding();
    }

    handleHelp = () => {
      const { store, translation } = this.props;
      const { AppStore, BrandStore } = store;

      const content = {
        heading: translation.help_dialog.heading,
        body: translation.help_dialog.body,
        button: translation.help_dialog.button
      }

      if (BrandStore.helpContent) {
        const { heading, body, button } = BrandStore.helpContent;
        content.heading = heading;
        content.body = body;
        content.button = button;
      }

      AppStore.showDialog(content, 'wide');
    }

    render() {
      const { store, translation } = this.props;
      const { BrandStore, UserStore } = store;
      const { installSid } = UserStore;
      const { showHelp } = BrandStore;
      const publicStart = getUrlSegment(1) === 'group';

      return (
        <header className="app-head" aria-labelledby="page-head">
          <h2 className="meta" id="page-head">Page header</h2>
          <a
            className="app-head__skip"
            href="#main-content"
            onClick={e => {
              e.preventDefault();
              const content = document.querySelector('#main-content');
              content && content.focus();
            }}
          >
            {translation.skip_to_content}
          </a>

          <div className="wrap">
            <div className="brand">
              {/* Default WGU logo */}
              {installSid !== config.gereSid &&
                <icons.wguLogo />
              }

              {/* GERE logo for WGU GERE install */}
              {installSid === config.gereSid &&
                <icons.wguGereLogo />
              }
            </div>

            <div className="app-head__tools">
              <Accessibility {...this.props} />

              {showHelp && !publicStart &&
                  <Button className="btn" onClick={this.handleHelp}>
                    <icons.questionCircle />
                    {translation.help}
                  </Button>
              }
            </div>
          </div>
        </header>
      );
    }
  }
);

export default translate('Header')(Header);
